module.exports = __webpack_public_path__ + "img/logoff.b242d01e.svg";